import type { AtomModel, TabSettingsData } from '@/app/editor/iframe/atom/Atom.model';
import { app } from '@/store';
import { mutations } from '@modules/libraries/store/types';
import type { Observer, Subject } from '@/app/editor/iframe/atom/service/observer';
import { DataManager } from '@/app/editor/iframe/atom/service/DataManager';
/**
 * Xuất hiện khi Atom hover
 */
export class ToolBar implements Observer {
  public $el: JQuery;
  /* Editor */
  public $gfLeftSideBar: JQuery = jQuery('#gfLeftSideBar');
  public $gfResTool: JQuery = jQuery('#gfResTool');
  public $divContentHidden: JQuery = jQuery('#divContentHidden');

  /* Iframe */
  public $gfFrame: JQuery = jQuery('#gfFrame');
  public $gfFrameWrap: JQuery = jQuery('#gfFrameWrap');
  public $gryffEditor: JQuery = this.$gfFrame.contents().find('.gryffeditor').first();
  public $gryffBody: JQuery = this.$gfFrame.contents().find('body').first();

  private currentAtomId: string;
  /** constructor
   * @param element DOM
   * @param options Seting
   */
  constructor(element: HTMLElement, options?: TabSettingsData) {
    this.$el = jQuery(element); // merge element to $el
    this.currentAtomId = this.$el.attr('data-id') || '';
    this.initTool();
    this.applyButtonActions();
    DataManager.registerObserver(this);
  }

  /**
   * update data change
   * @param subject obs
   */
  update(subject: Subject): void {
    if (DataManager.getState('isShowToolbar', this.currentAtomId)) {
      const data = DataManager.getState('showToolbar', this.currentAtomId);
      this.onShowTool(data?.force, data?.enableTool);
    } else {
      this.hideTool();
    }
  }

  /**
   * initTool
   */
  initTool(): void {
    const type = DataManager.getAtomDataById(this.currentAtomId).type;
    let aTool = '';
    let aHandle = '';
    switch (type) {
      case 'row': {
        aTool =
          '<ul class="gf-tool gf-r-tool gf-tool-wrap gf-r-tool-wrap"><li class="t-handle"><a class="r-handle"><span><svg class="editor move" width="14" viewBox="0 0 14 14"><path d="M11,10V8H8v3h2l-3,3l-3-3h2V8H3v2L0,7l3-3v2h3V3H4l3-3l3,3H8v3h3V4l3,3L11,10z"/></svg></span><span class="gf-tool-label">Row</span></a></li><li class="t-wrap r-wrap"><a class="r-export" title="Save row" onclick="return false;"><svg class="editor save" width="14" height="14" viewBox="0 0 14 14"><path d="M12.2499 9.78559V12.4106H1.74999V9.78559H0V12.4106C0 13.3731 0.787495 14.1606 1.74999 14.1606H12.2499C13.2124 14.1606 13.9999 13.3731 13.9999 12.4106V9.78559H12.2499ZM11.3749 6.28561L10.1412 5.05187L7.87495 7.30935V0.160645H6.12496V7.30935L3.85873 5.05187L2.62498 6.28561L6.99996 10.6606L11.3749 6.28561Z"/></svg></a><a class="r-clone" title="Clone Row" onclick="return false;"><svg class="editor duplicate" width="14" viewBox="0 0 14 14"><path d="M10,10H0V0h10V10z M12,4v8H4v2h10V4H12z"/></svg></a><a class="r-remove" title="Remove Row"><svg class="editor delete" width="14" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7c0,3.9,3.1,7,7,7s7-3.1,7-7C14,3.1,10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4 L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z"/></svg></a></li><li class="t-collapse"><a title="Expand / Collapse"><svg class="editor expand" width="8" viewBox="0 0 8 14"><path d="M1,3l4,4l-4,4V3z"/></svg></a></li></ul>';
        aHandle = '.r-handle';
        break;
      }
      case 'module': {
        aTool =
          '<ul class="gf-tool gf-m-tool gf-tool-wrap gf-m-tool-wrap"><li class="t-handle"><a class="m-handle"><span><svg class="editor move" width="14" viewBox="0 0 14 14"><path d="M11,10V8H8v3h2l-3,3l-3-3h2V8H3v2L0,7l3-3v2h3V3H4l3-3l3,3H8v3h3V4l3,3L11,10z"/></svg></span><span class="gf-tool-label">Module</span></a></li><li class="m-edit"><a class="m-edit"><svg class="need_a_name" height="14px" viewbox="0 0 14 14"><path d="M12.81,3.69c0.26-0.26,0.26-0.68,0-0.94l-1.56-1.56c-0.26-0.26-0.68-0.26-0.94,0L9.09,2.41l2.5,2.5L12.81,3.69zM1,10.5V13h2.5l7.37-7.37l-2.5-2.5L1,10.5z" /></svg></a></li><li class="t-wrap m-wrap"><a class="m-export" title="Save module"><svg class="editor save" width="14" height="14" viewBox="0 0 14 14"><path d="M12.2499 9.78559V12.4106H1.74999V9.78559H0V12.4106C0 13.3731 0.787495 14.1606 1.74999 14.1606H12.2499C13.2124 14.1606 13.9999 13.3731 13.9999 12.4106V9.78559H12.2499ZM11.3749 6.28561L10.1412 5.05187L7.87495 7.30935V0.160645H6.12496V7.30935L3.85873 5.05187L2.62498 6.28561L6.99996 10.6606L11.3749 6.28561Z"/></svg></a><a class="m-clone" title="Clone Module"><svg class="editor duplicate" width="14" viewBox="0 0 14 14"><path d="M10,10H0V0h10V10z M12,4v8H4v2h10V4H12z"/></svg></a><a class="m-remove" title="Delete Module"><svg class="editor delete" width="14" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7c0,3.9,3.1,7,7,7s7-3.1,7-7C14,3.1,10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4 L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z"/></svg></a></li><li class="t-collapse"><a title="Expand / Collapse"><svg class="editor expand" width="8" viewBox="0 0 8 14"><path d="M1,3l4,4l-4,4V3z"/></svg></a></li></ul>';
        aHandle = '.m-handle';
        break;
      }
      case 'element': {
        aTool =
          '<ul class="gf-tool gf-e-tool gf-tool-wrap gf-e-tool-wrap"><li class="t-handle"><a class="e-handle"><span><svg class="editor move" width="14" viewBox="0 0 14 14"><path d="M11,10V8H8v3h2l-3,3l-3-3h2V8H3v2L0,7l3-3v2h3V3H4l3-3l3,3H8v3h3V4l3,3L11,10z"/></svg></span><span class="gf-tool-label">Element</span></a></li><li class="e-edit"><a class="e-edit"><svg class="need_a_name" height="14px" viewbox="0 0 14 14"><path d="M12.81,3.69c0.26-0.26,0.26-0.68,0-0.94l-1.56-1.56c-0.26-0.26-0.68-0.26-0.94,0L9.09,2.41l2.5,2.5L12.81,3.69zM1,10.5V13h2.5l7.37-7.37l-2.5-2.5L1,10.5z" /></svg></a></li><li class="t-wrap e-wrap"><a class="e-export" title="Save element"><svg class="editor save" width="14" height="14" viewBox="0 0 14 14"><path d="M12.2499 9.78559V12.4106H1.74999V9.78559H0V12.4106C0 13.3731 0.787495 14.1606 1.74999 14.1606H12.2499C13.2124 14.1606 13.9999 13.3731 13.9999 12.4106V9.78559H12.2499ZM11.3749 6.28561L10.1412 5.05187L7.87495 7.30935V0.160645H6.12496V7.30935L3.85873 5.05187L2.62498 6.28561L6.99996 10.6606L11.3749 6.28561Z"/></svg></a><a class="e-clone" title="Clone Element"><svg class="editor duplicate" width="14" viewBox="0 0 14 14"><path d="M10,10H0V0h10V10z M12,4v8H4v2h10V4H12z"/></svg></a><a class="e-remove" title="Delete Element"><svg class="editor delete" width="14" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7c0,3.9,3.1,7,7,7s7-3.1,7-7C14,3.1,10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4 L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z"/></svg></a></li><li class="t-collapse"><a title="Expand / Collapse"><svg class="editor expand" width="8" viewBox="0 0 8 14"><path d="M1,3l4,4l-4,4V3z"/></svg></a></li></ul>';
        aHandle = '.e-handle';
        break;
      }
    }
    if (this.$el.children('.gf-tool-wrap').length == 0) {
      this.$el.append(aTool);
    }
    // set handle name
    const $aToolWrap = this.$el.children('.gf-tool-wrap');
    $aToolWrap.find(`${aHandle} span.gf-tool-label`).text(DataManager.getAtomDataById(this.currentAtomId).name);
    this.$el.off('mouseleave.tool').on('mouseleave.tool', () => {
      switch (type) {
        case 'row': {
          if (this.$el.hasClass('gf_row') && this.$el.data('gfrow') != undefined) {
            this.$el.data('gfrow').hideTool();
          }
          break;
        }
        case 'module': {
          if (this.$el.hasClass('module-wrap') && this.$el.data('gfmodule') != undefined) {
            this.$el.data('gfmodule').hideTool();
          }
          break;
        }
        case 'element': {
          if (this.$el.hasClass('element-wrap') && this.$el.data('gfelement') != undefined) {
            this.$el.data('gfelement').hideTool();
          }
          break;
        }
      }
    });

    return;
  }

  /**
   * Nhận và thực hiện các action từ button trong toolbar
   */
  applyButtonActions(): void {
    const _this = this;
    const $atom: any = this.$el;
    const $aToolWrap = this.$el.children('.gf-tool-wrap');
    const atomName = DataManager.getAtomDataById(this.currentAtomId).name;
    if (atomName == 'Liquid') {
      $aToolWrap.find('.m-data').remove();
    }

    $aToolWrap
      .find('.t-handle .gf-tool-label')
      .off('mousedown.scale')
      .on('mousedown.scale', function () {
        $aToolWrap.addClass('gf-tool-active');
        setTimeout(function () {
          $aToolWrap.removeClass('gf-tool-active');
        }, 100);
      });

    $aToolWrap
      .find('.m-edit')
      .off('mousedown.edit')
      .on('mousedown.edit', function (e: any) {
        e.preventDefault();

        if (atomName == 'Liquid') {
          if ($atom.data('gfmodule') != undefined) {
            _this.hideTool();
            $atom.data('gfmodule').moduleTemplate();
          }
        }
        return false;
      });

    // action buttons
    $aToolWrap
      .find('.t-collapse')
      .off('click')
      .on('click', function () {
        const $tool = jQuery(this).closest('.gf-tool');

        if ($tool.hasClass('gf-expand')) {
          $tool.removeClass('gf-expand');
        } else {
          $tool.addClass('gf-expand');
        }
        return false;
      });
    const type = DataManager.getAtomDataById(this.currentAtomId).type;
    let aExportClass = '';
    let aCLoneClass = '';
    let aRemoveClass = '';
    let aEditClass = '';
    let aHandleClass = '';
    let aSettingClass = '';
    switch (type) {
      case 'row': {
        aExportClass = '.r-export';
        aCLoneClass = '.r-clone';
        aRemoveClass = '.r-remove';
        aEditClass = '.r-edit';
        aHandleClass = '.r-handle';
        aSettingClass = '.r-settings';
        break;
      }
      case 'module': {
        aExportClass = '.m-export';
        aCLoneClass = '.m-clone';
        aRemoveClass = '.m-remove';
        aEditClass = '.m-edit';
        aHandleClass = '.m-handle';
        aSettingClass = '.m-settings';
        break;
      }
      case 'element': {
        aExportClass = '.e-export';
        aCLoneClass = '.e-clone';
        aRemoveClass = '.e-remove';
        aEditClass = '.e-edit';
        aHandleClass = '.e-handle';
        aSettingClass = '.e-settings';
        break;
      }
    }
    $aToolWrap
      .find(aExportClass)
      .off('click')
      .on('click', function () {
        (app as any).$store.commit(`library/${mutations.OPEN_CREATE_LIB}`, { type: 'block', target: $atom });
        return false;
      });
    $aToolWrap
      .find(aEditClass)
      .off('click')
      .on('click', function (e: any) {
        e.preventDefault();
        _this.hideTool();
        const elementName = _this.$el.attr('data-label');
        if (elementName == 'Heading' || elementName == 'Text Block') {
          _this.$gryffEditor.data('gftexteditor').onFocus($atom);
        }
        return false;
      });

    $aToolWrap
      .find(aCLoneClass)
      .off('click')
      .on('click', function () {
        _this.cloneMe();
        return false;
      });

    $aToolWrap
      .find(aRemoveClass)
      .off('click')
      .on('click', function () {
        //Close all setting left sidebar

        _this.$el.fadeOut(300, function () {
          _this.doRemoveMe();
          _this.$gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
        });
        return false;
      });
    $aToolWrap
      .find(`${aHandleClass}.gf-icon`)
      .off('click')
      .on('click', function () {
        $(this).parent().toggleClass('show-m-extra-tools');
      });
    $aToolWrap
      .find(`${aSettingClass},.m-handle:not(".gf-icon")`)
      .off()
      .on('click', function () {
        _this.openAtomSettings('Settings', true);
        return false;
      });
    this.$el.find('.item-content').each(function () {
      if (jQuery(this).children('.gf_add-content').length == 0) {
        jQuery(this).append(window._addContentBtn);
      }
    });
  }

  /**
   * Hiển thị toolbar
   * @param force ???
   * @param enableTool default show or hide tool
   */
  onShowTool(force = false, enableTool = true): void {
    let showTool = true;

    // Logic
    if (this.$el.attr('data-tool') == '0') {
      showTool = false;
    }
    if (this.$el.attr('data-resize') == 'true') {
      showTool = false;
    }

    if (!force) {
      if (
        this.$gryffEditor.data('gryffeditor').isDragging() ||
        this.$gryffEditor.data('gftexteditor').isEditing(this.$el)
      ) {
        showTool = false;
      }
    } else {
      showTool = true;
    }

    if (!enableTool) {
      showTool = false;
    }

    let showOutline = true;
    if (showTool) {
      const $aToolWrap = this.$el.children('.gf-tool-wrap');
      $aToolWrap.addClass('gf-tool-show');
      const atomName = DataManager.getAtomDataById(this.currentAtomId).name;
      switch (atomName) {
        case '(P) Title':
        case '(P) Description':
        case '(P) Price':
        case '(P) Stock Counter':
        case '(P) Cart Button':
        case '(P) View More':
        case '(P) Image':
        case '(P) Image List':
        case '(P) Quantity':
        case '(P) Variants':
        case '(P) Swatches':
        case '(A) Title':
        case '(A) Image':
        case '(A) Content':
        case '(A) Excerpt':
        case '(A) Date':
          showOutline = false;
          break;

        default:
          break;
      }

      const $atom: any = this.$el;
      const atomClass = DataManager.getAtomDataById(this.currentAtomId).class || '';
      let paddingTop = parseInt($atom.css('paddingTop'));
      const aWrapClass = $atom.attr('class');
      if (aWrapClass != '') {
        const $self = $atom.find(aWrapClass);
        let diff = 0;
        if ($self && $self.offset()) {
          diff = $self.offset().left - $atom.offset().left;
        }
        const left = diff + $self.outerWidth() / 2;
        $aToolWrap.css('left', left);
      } else {
        const left = $atom.outerWidth() / 2;
        $aToolWrap.css('left', left);
      }
      // item-content
      if ($atom.parent().hasClass('item-content')) {
        const $atomParent = $atom.parent().closest(atomClass);
        if ($atomParent) {
          paddingTop = parseInt($atomParent.css('paddingTop'));
          if (paddingTop == 0 && showOutline == true) {
            $aToolWrap.css('top', '30px');
          }
        }
      }
      // Module Popup fix tools
      if ($atom.attr('data-label') == 'Popup') {
        $aToolWrap.css('top', '0px');
        const $aToolWrapOffset = $aToolWrap && $aToolWrap.offset();
        if ($aToolWrapOffset && $aToolWrapOffset.top >= 40) {
          $aToolWrap.css('top', '-30px');
        }
        if ($aToolWrap.next('.gf-popupBgTool').length == 0) {
          $aToolWrap.after(
            '<div class="gf-popupBgTool" style="position:absolute;top:-30px;width:100%;height:30px;z-index:-1;"></div>',
          );
        }
      }
    }

    if (this.$el.data('gfoutline') != undefined && showOutline) {
      this.$el.data('gfoutline').showOutline();
    }
  }

  /**
   * Bắn sự kiện cloneMe cho Atom xử lý
   */
  cloneMe() {
    // STORE.events.trigger(`cloneMe-${this.data.atom.id}`);
    DataManager.setState('cloneMe', true, this.currentAtomId);
    DataManager.getInstance().notify();
  }
  /**
   * Bắn sự kiện doRemoveMe cho Atom xử lý
   */
  doRemoveMe() {
    //   this.emit("doRemoveMe");
    // STORE.events.trigger(`doRemoveMe-${this.data.atom.id}`);
    DataManager.setState('remove', true, this.currentAtomId);
    DataManager.getInstance().notify();
    DataManager.removeObserver(this);
  }

  /**
   * Ẩn toolbar
   * @param force ???
   */
  hideTool(force?: boolean): void {
    if (
      !window._isContextOpenned ||
      (this.$gryffBody.data('gfcontextmenu') &&
        this.$gryffBody.data('gfcontextmenu').getTargetMERId() != this.$el.attr('id')) ||
      force == true
    ) {
      if (!this.$gryffEditor.data('gryffeditor').isDragging() || force == true) {
        const $mToolWrap = this.$el.children('.gf-tool-wrap');
        $mToolWrap.removeClass('gf-tool-show');

        if (this.$el.data('gfoutline') != undefined) {
          this.$el.data('gfoutline').hideOutine();
        }
      }
    }
    this.$el.removeClass('gf_primary-tool');

    return;
  }

  /**
   * Lấy tên class của Atom
   * @param atomModel AtomModel
   * @returns class name
   */
  getTargetClass(atomModel: AtomModel): string {
    const targetClass = atomModel ? atomModel.class : '';
    return targetClass;
  }
  /**
   * Yêu cầu mở tab setting ở Atom thông qua store
   * @param tab Tên tab (Setitngs)
   * @param drag Được kéo vào hoặc không (true/false)
   */
  openAtomSettings = (tab: string, drag = false): void => {
    DataManager.setTabSettingsDataField(
      {
        tab: tab,
        drag: drag,
        capture: false,
        forceOpen: false,
      },
      this.currentAtomId,
    );
    DataManager.setState('openSetting', true, this.currentAtomId);
    DataManager.getInstance().notify();
  };
}
